import { Helmet } from "react-helmet-async"
import { SupplierList } from "../../../Supplier"
import { FeatureFlag, ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function VisaSupplierPage() {
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.MANAGE_VISA_SUPPLIERS}
		>
			<Helmet>
				<title>Visa Supplier</title>
			</Helmet>
			<FeatureFlag flag="visa" show404>
				<SupplierList title="Visa Suppliers" supplierType="visas" />
			</FeatureFlag>
		</ForbidUnlessAuthorized>
	)
}
